import { useManagementGetUnitCancelled } from '@apps-common/apis/management/unit-cancelled'
import { CardContainer } from '@apps-common/components/common'
import { SectionTitle } from '@apps-common/components/common/portal-title'
import { CheckboxInputSM, InputInfoSM } from '@apps-common/components/elements/form'
import { VertSpacerLg } from '@apps-common/components/layout'
import { valueStringCheck } from '@apps-common/helpers/value-string-check'
import { IManagementUnitSelectItem, useManagementUnitSelectItems } from '@apps-common/hooks/useManagementUnitSelectItems'

interface IProps {
  unitId?: string
}

export const UnitCancelledDetailsManagementForm: React.FC<IProps> = ({ unitId }) => {
  const {
    data: cancelledUnit,
    isLoading: cancelledIsLoading,
    isRefetching: cancelledIsRefetching,
    isError: cancelledIsError,
    refetch: cancelledRefetch
  } = useManagementGetUnitCancelled({ config: {}, unitId: unitId || '' })

  const { isLoading: selectItemsLoading, companies, products, plans, firmwares, simApns, simTypes } = useManagementUnitSelectItems()
  // const { mutate: createUnit, isPending: createIsPending } = useManagementCreateUnitActive(true, (unit) => doneCallback(unit))
  // const { mutate: updateUnit, isPending: updateIsPending } = useManagementUpdateUnitActive(true, (unit) => doneCallback(unit))

  // const {
  //   register,
  //   handleSubmit,
  //   formState: { isSubmitting, errors },
  //   watch,
  //   setValue,
  //   reset
  // } = useForm<IUnitSimCancelledModel>({
  //   mode: 'onChange',
  //   reValidateMode: 'onChange'
  // })

  // useEffect(() => {
  //   if (cancelledUnit) {
  //     reset(cancelledUnit)
  //   }
  // }, [cancelledUnit])

  const getSelectValue = (id: string | undefined, options: IManagementUnitSelectItem) => {
    const item = options?.options?.find((o) => o.value === id)

    return valueStringCheck(item?.label)
  }

  const isLoading = selectItemsLoading || cancelledIsLoading || cancelledIsRefetching || cancelledIsError

  return (
    <div>
      <div className='grid md:grid-cols-2 gap-[20px] max-w-[1200px]'>
        <div className='flex flex-col gap-[20px]'>
          <CardContainer bgClasses='bg-surface border border-border'>
            <SectionTitle text='Company' classes='ml-[10px] text-text' />
            <VertSpacerLg />
            <div className='grid lg:grid-cols-2 gap-x-[20px]'>
              <InputInfoSM
                label='Monitoring Centre'
                id='monitoringCentreId'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={getSelectValue(cancelledUnit?.monitoringCentreId, companies)}
              />
              <InputInfoSM
                label='Bureau'
                id='bureauId'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={getSelectValue(cancelledUnit?.bureauId, companies)}
              />
              <InputInfoSM
                label='Technician'
                id='techCompanyId'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={getSelectValue(cancelledUnit?.techCompanyId, companies)}
              />
            </div>
          </CardContainer>
          <CardContainer bgClasses='bg-surface border border-border'>
            <SectionTitle text='Device' classes='ml-[10px] text-text' />
            <VertSpacerLg />
            <div className='grid lg:grid-cols-2 gap-x-[20px]'>
              <InputInfoSM
                label='Product'
                id='productId'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={getSelectValue(cancelledUnit?.productId, products)}
              />
              <InputInfoSM
                label='Plan'
                id='unitPlanId'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={getSelectValue(cancelledUnit?.unitPlanId, plans)}
              />
              <InputInfoSM
                label='Plan'
                id='unitFirmwareId'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={getSelectValue(cancelledUnit?.unitFirmwareId, firmwares)}
              />
              <InputInfoSM
                label='CID account'
                id='accountNo'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={valueStringCheck(cancelledUnit?.accountNo)}
              />
              <InputInfoSM
                label='IMEI number'
                id='imei'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={valueStringCheck(cancelledUnit?.imei)}
              />
              <InputInfoSM
                label='Serial number'
                id='serialNo'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={valueStringCheck(cancelledUnit?.serialNo)}
              />
              <CheckboxInputSM
                label='Line supervision'
                id='lineSupervision'
                loading={isLoading}
                disabled
                registration={{
                  checked: cancelledUnit?.lineSupervision
                }}
              />
            </div>
          </CardContainer>
        </div>
        <div>
          <CardContainer bgClasses='bg-surface border border-border'>
            <SectionTitle text='Sim Card' classes='ml-[10px] text-text' />
            <VertSpacerLg />
            <div className='grid lg:grid-cols-2 gap-x-[20px]'>
              <InputInfoSM
                label='APN'
                id='simApnId'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={getSelectValue(cancelledUnit?.simApnId, simApns)}
              />

              <InputInfoSM
                label='Sim Type'
                id='simTypeId'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={getSelectValue(cancelledUnit?.simTypeId, simTypes)}
              />
              <InputInfoSM
                label='Mobile number'
                id='mobileNo'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={valueStringCheck(cancelledUnit?.mobileNo)}
              />
              <InputInfoSM
                label='Sim card number'
                id='simNo'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={valueStringCheck(cancelledUnit?.simNo)}
              />
              <InputInfoSM
                label='Sim IP address'
                id='ip'
                className='px-[10px]'
                hideNoEditIcon
                showLabel
                loading={isLoading}
                value={valueStringCheck(cancelledUnit?.ip)}
              />
            </div>
          </CardContainer>
        </div>
      </div>
      <VertSpacerLg />
    </div>
  )
}
